export default __webpack_public_path__ + "static/media/arrow.bc553588.svg";